import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AuthService } from '../../shared/src/lib/services/auth/auth.service';
import { APP_INITIALIZER, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {
  provideHttpClient,
  withInterceptors,
  } from '@angular/common/http';
import { jwtInterceptor } from '../../shared/src/lib/utils/interceptors/jwt.interceptor';
import {
  errorInterceptor,
  loadingIndicatorInterceptor,
  AppLayoutModule,
  TalkjsChatComponent,
} from 'shared';
import { AppRoutingModule } from './app/app-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { ClaimsRoutingModule } from './app/pages/claims/claims-routing.module';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { providePrimeNG } from 'primeng/config';
import { PhiPreset } from '../../shared/src/lib/theme/phi-preset';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      if (authService.isAuthenticated()) {
        resolve(true);
        // console.log('Authenticated');
      } else {
        // console.log('Not Authenticated');
        resolve(false);
        authService.logout();
      }
    });
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideAnimationsAsync(),
    importProvidersFrom(
      AppRoutingModule,
      // AppLayoutModule,
      // TalkjsChatComponent,
      TranslateModule.forRoot()
      // ClaimsRoutingModule
    ),
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    // EventService,
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    ...provideTranslateHttpLoader(),
    provideHttpClient(withInterceptors([jwtInterceptor, errorInterceptor, loadingIndicatorInterceptor])),
    providePrimeNG({ theme: { preset: PhiPreset, options: { darkModeSelector: '.app-dark' } } }),
  ],
}).catch((err) => console.error(err));
